import { defineMessages } from 'react-intl';

export default defineMessages({
  impersonatedUserDetails: {
    id: 'impersonatedUserDetails',
    defaultMessage: 'User Details for: {name}',
  },
});
